import { render } from "./IconoConBorrar.vue?vue&type=template&id=7a65d946&scoped=true"
const script = {}

import "./IconoConBorrar.vue?vue&type=style&index=0&id=7a65d946&lang=sass&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a65d946"]])

export default __exports__